import React from 'react';
import { View } from 'react-native';

import tw from '../../styles/tailwind';
import { tutorialUrl } from './tutorials';


/** En web el tutorial va en un iframe; no tiene el problema de textZoom de Android. */
export default function TutorialView({ slug, style = {} }: { slug: string; style?: any }) {
  return (
    <View style={tw.style(`flex-1 bg-white rounded-2xl overflow-hidden`, style)}>
      <iframe
        src={tutorialUrl(slug)}
        title='Tutorial'
        allow='autoplay'
        style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
      />
    </View>
  );
}
